import React,{useState} from 'react'
import Filters from '../../Components/Filters';
import CoursesCard from './CoursesCard'

function Courses() {
    // let courses =[1, 2, 3,4,5, 6, 7,8,9,10,11,12,13,14,15]
    let  courses= [
      {
          title: "PHP for Beginners",
          category: "PHP",
          keyPoints:["Learn how to create a dynamic website using the most popular website programming language","Build a working CMS in PHP and MySQL from scratch","Learn how to secure your code"],
          price: 1200,
          rating: 4,
          teacher:"Praveen soni",
          img:"--"
      },
      {
        title: "JavaScript: Understanding the Weird Parts",
        category: "JavaScript",
        keyPoints:["Grasp how Javascript works and it's fundamental concepts","Write solid, good Javascript code","Understand advanced concepts such as closures, prototypal inheritance, IIFEs, and much more."],
        price: 2300,
        rating: 5,
        teacher:"Suraj chaudhary",
        img:"--"
      },
      {
          title: "Zero to Hero in python",
          category: "Python",
          keyPoints:["Learn to use Python professionally, learning both Python 2 and Python 3!","Create games with Python, like Tic Tac Toe and Blackjack!","Learn advanced Python features, like the collections module and how to work with timestamps!"],
          price: 1400,
          rating: 4,
          teacher:"Sonack singh",
          img:"--"
      },
      {
          title: "python programming masterclass",
          category: "Python",
          keyPoints:["Have a fundamental understanding of the Python programming language.","Have the skills and understanding of Python to confidently apply for Python programming jobs.","Acquire the pre-requisite Python skills to move into specific branches - Machine Learning, Data Science, etc.."],
          price: 2000,
          rating: 5,
          teacher:"Sundar Ram",
          img:"--"
      },
      {
          title: "PHP for Beginners",
          category: "Php",
          keyPoints:["Learn how to create a dynamic website using the most popular website programming language","Build a working CMS in PHP and MySQL from scratch","Learn how to secure your code"],
          price: 1200,
          rating: 4,
          teacher:"Praveen soni",
          img:"--"
      },
      {
          title: "Complete Web Development bootcamp",
          category: "Web Development",
          keyPoints:["The ins and outs of HTML5, CSS3, and Modern JavaScript for 2021","Make REAL web applications using cutting-edge technologies","Create responsive, accessible, and beautiful layouts"],
          price: 2500,
          rating: 5,
          teacher:"Sagar Dalal",
          img:"--"
      },
      {
          title: "Machine Learning A-Z™: Hands-On Python &amp; R In Data Science",
          category: "Data Science",
          keyPoints:["Master Machine Learning on Python & R","Have a great intuition of many Machine Learning models","Make accurate predictions"],
          price: 2800,
          rating: 3,
          teacher:"Amrit Roy",
          img:"--"
      },
      {
          title: "The Complete JavaScript Course 2022",
          category: "JavaScript",
          keyPoints:["Become an advanced, confident, and modern JavaScript developer from scratch","Build 6 beautiful real-world projects for your portfolio (not boring toy apps)","Become job-ready by understanding how JavaScript really works behind the scenes"],
          price: 2200,
          rating: 4.5,
          teacher:"Sahil Saif",
          img:"--"
      },
      {
          title: "Complete python developer in 2022",
          category: "Python",
          keyPoints:["Become a professional Python Developer and get hired","modern Python 3.10(latest) fundamentals as well as advanced topics","Object Oriented Programming"],
          price: 1000,
          rating:3.5,
          teacher:"Anuradha Das",
          img:"--"
      },
      {
          title: "The Data Science Course 2022: Complete Data Science Bootcamp",
          category: "Data Science",
          keyPoints:["Impress interviewers by showing an understanding of the data science field","Impress interviewers by showing an understanding of the data science field"],
          price: 800,
          rating: 4,
          teacher:"Sammer Roy",
          img:"--"
      },
      {
          title: "Write PHP like a pro",
          category: "PHP",
          keyPoints:["Separate application code from presentation code","Organise your PHP code into models, views and controllers in an MVC framework","Use namespaces and an autoloader to load PHP classes automatically"],
          price: 1500,
          rating: 4.5,
          teacher:"Ayush sharma",
          img:"--"
      },
      {
          title: "The Modern Python 3 bootcamp",
          category: "Python",
          keyPoints:["Learn all the coding fundamentals in Python!","Work through nearly 200 exercises and quizzes!","Learn about all of the latest features in Python 3.6"],
          price: 1800,
          rating: 3.5,
          teacher:"Priti singh",
          img:"--"
      },
      {
          title: "Android Jetpack Compose: The Comprehensive Bootcamp [2022]",
          category: "Android",
          keyPoints:["Make pretty much any Android app you like (your only limit is your imagination)","Submit your apps to Google Play and generate revenue with Google Pay and Google Ads","Become a professional app developer, take freelance gigs and work from anywhere in the world"],
          price: 3000,
          rating: 4.5,
          teacher:"Sam Smith",
          img:"--"
      },
    
  ]
  const [availableCourses, setavailableCourses] = useState(courses)
  let handleFiltering = (heading, data) => {
    console.log("hello");
    switch (heading) {
        case "Category":
            if (data == "All") {
                setavailableCourses(courses)
            }
            else {
                let category_items = courses.filter(i => i.category == data);
                setavailableCourses(category_items);
            }
            break
        case "Price Range":
            console.log(data);
            let priceWiseItem = courses.filter(i => i.price >= data[0] && i.price <data[1]);
            console.log(priceWiseItem)
            setavailableCourses(priceWiseItem)
            break
        case "Rating":
            let ratingWiseItem = courses.filter(i => data==Math.floor(i.rating));
            setavailableCourses(ratingWiseItem)
            break
        default:
            break;
    }
  }
  return (
    <div style={{ marginTop: '10%' }}>
    <div className="container d-flex justify-content-center">
          <Filters handleFiltering={handleFiltering}  heading="Category" options={["All", "PHP", "JavaScript", "Python",  "Web Development", "Data Science","Android"]} />
          <Filters handleFiltering={handleFiltering}  heading="Price Range" minRange={600} maxRange={3500} dis={500} intitialrange={[700,1500]} />
          <Filters handleFiltering={handleFiltering}  heading="Rating" options={[1, 2, 3,4,5]} />
    </div>
    <div className="d-flex  flex-wrap justify-content-center">
    {availableCourses.map((course)=>{
        return <CoursesCard title={course.title} keyPoints={course.keyPoints} price={course.price} rating={course.rating} teacher={course.teacher} category={course.category}  img={course.img} />
    })}
    </div>
    </div>
  )
}

export default Courses